import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b286fc80&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\project\\bin-ace-editor\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b286fc80')) {
      api.createRecord('b286fc80', component.options)
    } else {
      api.reload('b286fc80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b286fc80&", function () {
      api.rerender('b286fc80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/index.vue"
export default component.exports